import { render, staticRenderFns } from "./IconTeams.vue?vue&type=template&id=0ec247f8"
import script from "./IconTeams.vue?vue&type=script&lang=js"
export * from "./IconTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports